import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AppBar, Toolbar, IconButton, Dialog, Avatar, CardHeader, FormControlLabel, Radio, RadioGroup, TextField, Typography, CircularProgress } from '@material-ui/core'
import { index, clear } from '../../../store/actions/top.action'
import { FcFilingCabinet, FcTreeStructure } from 'react-icons/fc'
import { MdKeyboardBackspace } from 'react-icons/md'
import { changeScreen } from '../../../store/actions/navigation.action'
import Detail from './detail'
import Fullname from '../../components/Fullname'

export default function MaisComprou(props) {
    const dispatch = useDispatch()
    const { top, title } = useSelector(state => state.topReducer)
    const campaign_id = (props.uid) ? props.uid : null
    const [isLoad, setLoad] = React.useState(true)
    const [isLoading, setLoading] = React.useState(true)

    const date = new Date();
    const dateInit = new Intl.DateTimeFormat('pt-BR', {year: 'numeric'}).format(new Date(date))+'-'+ new Intl.DateTimeFormat('pt-BR', {month: '2-digit'}).format(new Date(date)) +'-'+new Intl.DateTimeFormat('pt-BR', {day: '2-digit'}).format(new Date(date))+'T00:00'
    const dateEnd = new Intl.DateTimeFormat('pt-BR', {year: 'numeric'}).format(new Date(date))+'-'+ new Intl.DateTimeFormat('pt-BR', {month: '2-digit'}).format(new Date(date)) +'-'+new Intl.DateTimeFormat('pt-BR', {day: '2-digit'}).format(new Date(date))+'T23:59'

    const [dateInitial, setDateInitial] = React.useState(dateInit)
    const [dateFinal, setDateFinal] = React.useState(dateEnd)

    const [qtd, setQtd] = React.useState(3)

    const [detail, setDetail] = React.useState({
        top: null,
        index: null,
        open: false
    })

    React.useEffect(() => {
        return () => {
            dispatch(clear())
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    React.useEffect(() => {
        setLoad(true)
        dispatch(index(campaign_id, qtd, new Date(dateInitial), new Date(dateFinal))).then(() => {
            setLoad(false)
            setLoading(false)
        })
    }, [qtd, dateInitial, dateFinal])

    const _detail = (top, index) => {
        setDetail({
            top: top,
            open: true,
            index: index
        })
    }

    return (
        <>
        <div className="app-bar">
            <AppBar position="fixed">
                <Toolbar>
                    <IconButton onClick={() => dispatch(changeScreen({ open: false }))} edge="start" color="inherit">
                        <MdKeyboardBackspace />
                    </IconButton>
                    <Typography variant="h6" className="line-clamp-1">
                        {title}
                    </Typography>
                </Toolbar>
            </AppBar>

            <Dialog
                open={detail.open}
                maxWidth="sm"
				style={{width: '100%'}}
                onClose={() => setDetail({ top: null, index: null, open: false })}
                className="center"
            >   
                <Detail index={detail.index} top={detail.top} title={title} onClose={() => setDetail({ top: null, index: null ,open: false })}/>
            </Dialog>

            {(isLoading) ? <div className="d-flex justify-content-center m-5 p-5"> <CircularProgress /> </div> :
            <>
                <div className="card p-3 mt-3 mb-2 bs-bg">
                    <div className="row mb-3 mt-2">
                        <div className="col-6 col-lg-6">
                            <div className="date">
                                <label className="label-date bs-color-b">
                                    {(dateInitial) && new Intl.DateTimeFormat('pt-BR', {year: 'numeric', month: '2-digit',day: '2-digit'}).format(new Date(dateInitial))}&nbsp;&nbsp;&nbsp;
                                    {(dateInitial) && new Intl.DateTimeFormat('pt-BR', {hour: '2-digit', minute: '2-digit'}).format(new Date(dateInitial))}    
                                </label>
                                <TextField
                                    id="datetime-local"
                                    label="Data Inicial"
                                    type="datetime-local"
                                    defaultValue={dateInitial}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onBlur={e => {
                                        if(e.target.value) {
                                            setDateInitial(e.target.value)
                                        } else {
                                            setDateInitial(dateInit)
                                        }
                                    }}
                                />
                            </div>
                        </div>
                        <div className="col-6 col-lg-6">
                            <div className="date">
                                <label className="label-date bs-color-b">
                                    {(dateFinal) && new Intl.DateTimeFormat('pt-BR', {year: 'numeric', month: '2-digit',day: '2-digit'}).format(new Date(dateFinal))}&nbsp;&nbsp;&nbsp;
                                    {(dateFinal) && new Intl.DateTimeFormat('pt-BR', {hour: '2-digit', minute: '2-digit'}).format(new Date(dateFinal))}    
                                </label>
                                <TextField
                                    id="datetime-local"
                                    label="Data Final"
                                    type="datetime-local"
                                    defaultValue={dateFinal}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onBlur={e => {
                                        if(e.target.value) {
                                            setDateFinal(e.target.value)
                                        } else {
                                            setDateFinal(dateEnd)
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="mb-3">
                        <RadioGroup
                            row
                            name="type"
                            value={parseInt(qtd)}
                            onChange={text => {
                                setQtd(text.target.value)
                            }}
                            className="fw-normal bs-color-b"
                        >
                            <FormControlLabel value={3} control={<Radio color="primary" />} label="TOP 3" />
                            <FormControlLabel value={5} control={<Radio color="primary" />} label="TOP 5" />
                            <FormControlLabel value={10} control={<Radio color="primary" />} label="TOP 10" />
                        </RadioGroup>
                    </div>

                </div>

            {(isLoad) ? <div className="d-flex justify-content-center m-5 p-5"> <CircularProgress /> </div> :
                <>
                {(top.length < 1) &&
                    <div className="card card-body mt-3 bs-bg">
                        <div className="text-center mt-5 pt-5 mb-5 pb-5">
                            <FcFilingCabinet size="70" />
                            <h6 className="mt-4 text-muted bs-color">Nenhum registro encontrado</h6>
                        </div>
                    </div>
                }

                {(top.length > 0) &&
                    <>
                        {top.map((item, index) => (
                            <div className="card pointer bs-bg list-items" key={index} onClick={() => _detail(item, (index + 1))}>
                                <CardHeader 
                                    avatar={
                                        <Avatar className="avatar-item">
                                            <span className="fw-bold">{index + 1}</span>
                                        </Avatar>
                                    }
                                    title={<h6 className="fw-bold bs-color-b"><Fullname fullName={item.user.name ? item.user.name.substring(0,24) : item.user.name} /></h6>}
                                    subheader={<>
                                        <span className="d-block bs-color">{item.user.telefone ? item.user.telefone.substring(0,5) : item.user.telefone}**-****</span>
                                        <span className="d-block bs-color">Valor investido: {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.total)}</span>
                                    </>}
                                    
                                    action={<h6 className="fw-bold p-3 bs-color-b"><FcTreeStructure size={20} className="me-2" /> {item.qtd.toLocaleString('pt-BR', {style: 'decimal'})}</h6>}
                                />
                            </div>
                        ))}
                    </>
                }
                </>
            }
            </>
        }
        </div>
        </>
    )
}